/**
 * The investor pages that are linked from more than one place — the unified rail and its Back
 * labels, the legacy rail and header menus, the screeners' own tabs — spelled once so a rename
 * cannot leave one of those behind. Each path names what the page shows under the label users see
 * for it, not the persona or the component behind it (PLT-6931).
 *
 * The spellings these replaced stay routed as redirects in `redirect-routes.tsx`, which carry the
 * query string and hash across: screener filters live in the query string, and old links to them
 * are in blog posts and release notes.
 *
 * Entity profiles (`/company/…`, `/company-group/…`, `/portfolio/…`) are deliberately not here.
 * Their prefix follows the table the entity lives in, and a company group is a fund only when its
 * `groupType` is `fund` — it can equally be an index, a generic group, or a client, loan or grant
 * portfolio — so a `/fund/…` URL would mislabel every other kind.
 */

/** The organisation's assets table: the rail's *Funds and portfolios*. */
export const FUNDS_AND_PORTFOLIOS_PATH = '/funds-and-portfolios';

export const CUSTOM_COMPANIES_PATH = '/custom-companies';

/** Who the organisation's assets are shared with: the rail's *Manage access*, or *Shared assets* for self-serve organisations. */
export const MANAGE_ACCESS_PATH = '/manage-access';

export const FAVORITES_PATH = '/favorites';

/** The three screeners share one route tree (`advanced-search-view`) under this base. */
export const SCREENER_BASE_PATH = '/screen';
export const SCREEN_COMPANIES_PATH = `${SCREENER_BASE_PATH}/companies`;
export const SCREEN_FUNDS_PATH = `${SCREENER_BASE_PATH}/funds`;
export const SCREEN_FUND_HOLDINGS_PATH = `${SCREENER_BASE_PATH}/fund-holdings`;

/** The holdings screener opened on one fund or portfolio. */
export function screenFundHoldingsPath(entityType: string, id: string): string {
  return `${SCREEN_FUND_HOLDINGS_PATH}/${entityType}/${id}`;
}

/** Any of the screeners, including the bare base that redirects to the company screener. */
export function isScreenerPath(pathname: string): boolean {
  return pathname === SCREENER_BASE_PATH || pathname.startsWith(`${SCREENER_BASE_PATH}/`);
}
